import React from 'react';

const Feedback = () => {
  const testimonials = [
    {
      name: 'Harshitha - DAV',
      feedback: 'Gayathri ma’am makes Chemistry so engaging and easy to understand. Her patience, enthusiasm, and clarity help us grasp even complex topics with confidence. She creates such a warm and motivating learning space that makes every class enjoyable. I’m truly grateful to have her as my teacher — she has won all our hearts! ❤️'
    },
    {
      name: 'Shruthi - Modern Senior Secondary School', 
      feedback: 'Whenever I think about Chemistry, the first person who comes to mind is Gayathri ma’am. Even after passing out of 12th, I still recall her inspiring way of teaching every time I hear the word Chemistry. She truly made learning a joyful experience and a cherished part of my journey. 🌸'
    },
    {
      name: 'Abhijith - Class 12',
      feedback: 'Gayathri ma’am completely changed the way I looked at Chemistry. I started enjoying the subject instead of just memorizing it. Her trust in me, even when I didn’t perform well, kept me motivated to do better. I’m forever grateful for her guidance, patience, and constant support. 🙏🏼'
    },
    {
      name: 'Bhargavi - Class 12',
      feedback: 'Thank you for all the support and guidance that you have given to me 🙏. Thank you for never losing hope in me. That\'s the only thing that made me keep going despite my performance in every test 🥺. It\'s an honour to be your student and I hope I\'ll live up to it 🙏.'
    },
    {
      name : 'Pooja - Pon Vidhyashram',
      feedback : 'Gayathri Mam\'s influence truly extended beyond the classroom, teaching me how to stay disciplined in life and inspiring me in so many ways. I’m honestly short of words to express my respect. Even though I’ve graduated high school, whenever I hear the word \'Chemistry,\' this teacher is the first person who comes to mind. forever grateful!'
    },
    {
      name : 'Sai Pragathi',
      feedback : 'Every shocking question in your class made my head knock and my hands turn the pages of NCERT. When no one else believed in me, you recognized my knowledge and helped me believe in it too. Even that last call before my board exam gave me the strength to give my 100% and achieve centum.'
    }
  ];

  const googleReviews = [
    {
      name: 'Saai Meera',
      timeAgo: 'June 2026',
      feedback: 'Gayathri mam is a very good teacher. She is the one who always teaches each and every concept in the most enjoyable manner and made chemistry as my favourite subject. She always ensures that each and every student understands all the topics and makes them confident in each and every topic. After teaching a topic she always recollects it again and again so that we never forget it, which was really helpful for me to achieve centum in my chemistry board exam. Thank you very much mam for all your efforts!!',
      url: 'https://maps.app.goo.gl/tqTkX4Eb1LvbXX9V8'
    },
    {
      name: 'Latha Kuppusamy',
      timeAgo: 'June 2026',
      feedback: 'A heartfelt thank you to my Chemistry teacher, whose dedication, guidance, and constant support played a significant role in helping me score 99 marks in Chemistry. Her ability to explain concepts clearly, patiently address doubts, and motivate students made learning both effective and enjoyable. This achievement would not have been possible without her efforts and encouragement. Deeply grateful for her invaluable contribution to this success.',
      url: 'https://maps.app.goo.gl/EFRtMUPsfe8qugS4A'
    }
  ];

  return (
    <section id="feedback" className="section">
      <div className="container">
        <h2 className="section-title">Student Voice</h2>
        <p className="section-subtitle">
          What Our Students Say About Our Chemistry Classes
        </p>
        
        <div className="google-reviews-wrapper">
          {googleReviews.map((review, index) => (
            <a
              key={`google-${index}`}
              href={review.url}
              target="_blank"
              rel="noopener noreferrer"
              className="feedback-card google-review-card"
            >
              <div className="google-review-header">
                <div className="google-review-avatar">
                  {review.name.charAt(0)}
                </div>
                <div className="google-review-meta">
                  <div className="google-review-name">{review.name}</div>
                  <div className="google-review-stars-row">
                    <span className="google-review-stars">★★★★★</span>
                    <span className="google-review-time">{review.timeAgo}</span>
                  </div>
                </div>
                <svg className="google-g-icon" width="22" height="22" viewBox="0 0 48 48" aria-hidden="true">
                  <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.6 32.9 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.1 8 3l6-6C34.5 5.5 29.5 3.5 24 3.5 12.7 3.5 3.5 12.7 3.5 24S12.7 44.5 24 44.5c11 0 20.5-8 20.5-20.5 0-1.4-.2-2.7-.4-4z"/>
                  <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 15.9 18.9 13.5 24 13.5c3.1 0 5.8 1.1 8 3l6-6C34.5 6.5 29.5 3.5 24 3.5c-7.7 0-14.3 4.4-17.7 11.2z"/>
                  <path fill="#4CAF50" d="M24 44.5c5.4 0 10.2-1.8 14-5l-6.5-5.5c-2 1.4-4.6 2.3-7.5 2.3-5.2 0-9.6-3.1-11.3-7.6l-6.5 5C9.6 40 16.3 44.5 24 44.5z"/>
                  <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.3 5.7l6.5 5.5C41 35.9 44.5 30.5 44.5 24c0-1.4-.2-2.7-.9-3.5z"/>
                </svg>
              </div>
              <div className="feedback-text google-review-text">"{review.feedback}"</div>
              <div className="student-info google-review-footer">
                <span className="google-review-link">Read full review on Google Maps</span>
              </div>
            </a>
          ))}
        </div>

        <div className="feedback-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="feedback-card">
              <div className="feedback-text">"{testimonial.feedback}"</div>
              <div className="student-info">
                <div className="student-name">{testimonial.name}</div>
              </div>
            </div>
          ))}
        </div>

        <br />
        <br />
        <div className="student-name">And more . . .</div>
      </div>
    </section>
  );
};

export default Feedback;